import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { forEach } from 'lodash';

import Toolkit from '../Toolkit';
import FormulaSheet from '../FormulaSheet';
import PeriodicTable from '../PeriodicTable';

import './styles.scss';

/**
 * Component for mobile extendable container for toolkit icons.
 * */
const MobileToolkit = (props) => {
  const {
    learnosityData: { app },
    onShowModal,
    onCloseModal,
    annotationData,
    toggleAnnotations,
    isPreApSubject,
    allowCalculatorForItems,
    showCalculatorAllowedIcon,
    questionChanged,
    formulaSheet,
    periodicTable,
    isImpersonating,
    showQuestionBookmark,
    bookmarks,
    addBookmark,
    removeBookmark,
  } = props;

  const [formulaSheetOpen, setFormulaSheetOpen] = useState(false);
  const [periodicTableOpen, setPeriodicTableOpen] = useState(false);

  /**
   * Control visibility of the formula sheet
   * */
  const toggleFormulaSheet = (value) => {
    if (!!formulaSheet) {
      const action = value ? 'add' : 'remove';

      const formulaSheetContainer = document.querySelector(
        '.formula-sheet-container',
      );

      if (!!value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }

      formulaSheetContainer.classList[action]('--enabled');
      setFormulaSheetOpen(!!value);
    }
  };

  /**
   * Control visibility of the periodic table
   * */
  const togglePeriodicTable = (value) => {
    if (!!periodicTable) {
      const action = value ? 'add' : 'remove';

      const periodicTableContainer = document.querySelector(
        '.periodic-table-container',
      );

      if (!!value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }

      periodicTableContainer.classList[action]('--enabled');
      setPeriodicTableOpen(!!value);
    }
  };

  const renderResource = (resourceContainer, ResourceComponent) => {
    const mainContainer = document.querySelector(
      '.PlayerModeContainer--content',
    );
    const container = document.createElement('div');
    container.className = resourceContainer;
    mainContainer.insertBefore(container, mainContainer.firstChild);

    const sheetContainer = document.querySelector(`.${resourceContainer}`);

    ReactDOM.render(ResourceComponent, sheetContainer);
  };

  const renderFormulaSheet = () => {
    if (!!formulaSheet) {
      renderResource(
        'formula-sheet-container',
        <FormulaSheet
          formulaSheet={formulaSheet}
          isMobile
          onCloseClick={() => toggleFormulaSheet(false)}
        />,
      );
    }
  };

  const renderPeriodicTable = () => {
    if (!!periodicTable) {
      renderResource(
        'periodic-table-container',
        <PeriodicTable
          periodicTable={periodicTable}
          isMobile
          onCloseClick={() => togglePeriodicTable(false)}
        />,
      );
    }
  };

  const unmountDomComponents = (selector) => {
    const elements = document.querySelectorAll(selector);
    forEach(elements, (element) => {
      ReactDOM.unmountComponentAtNode(element);
      element.parentElement.removeChild(element);
    });
  };

  useEffect(() => {
    if (!!formulaSheet) {
      renderFormulaSheet();
    }

    return () => {
      unmountDomComponents('.formula-sheet-container');
    };
  }, [formulaSheet]);

  useEffect(() => {
    if (!!periodicTable) {
      // PREAP-2841 - temporary solution to make covered content scrollable
      // TODO: this should be removed when mobile redesign is implemented
      const lrnMiddleGroup = document.querySelector('.lrn-group-middle');
      lrnMiddleGroup.classList.add('lrn-content-bottom-spacer');

      renderPeriodicTable();
    }

    return () => {
      unmountDomComponents('.periodic-table-container');
    };
  }, [periodicTable]);

  return (
    <div className="mobile-toolkit-accordion">
      <div className="mobile-accordion-content">
        <Toolkit
          isMobile
          app={app}
          learnosityData={props.learnosityData}
          isPreApSubject={isPreApSubject}
          onShowModal={onShowModal}
          onCloseModal={onCloseModal}
          showAnnotationIcon={!!annotationData}
          toggleAnnotations={toggleAnnotations}
          allowCalculatorForItems={allowCalculatorForItems}
          showCalculatorAllowedIcon={showCalculatorAllowedIcon}
          questionChanged={questionChanged}
          showFormulaSheetIcon={!!formulaSheet}
          showQuestionBookmark={showQuestionBookmark}
          isImpersonating={isImpersonating}
          showPeriodicTableIcon={!!periodicTable}
          formulaSheetOpen={formulaSheetOpen}
          periodicTableOpen={periodicTableOpen}
          toggleFormulaSheet={toggleFormulaSheet}
          togglePeriodicTable={togglePeriodicTable}
          bookmarks={bookmarks}
          addBookmark={addBookmark}
          removeBookmark={removeBookmark}
        />
      </div>
    </div>
  );
};

export default MobileToolkit;
